export function scrollTransitions() {
	window.addEventListener('scroll', function () {
		let elements = document.querySelectorAll('.animate');
		for (let i = 0; i < elements.length; i++) {
			transition(elements[i], 200);
		}
	});
}

export function transition(element, margin) {
	let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	let offset = getOffset(element)
	let topOfObject = offset.top + margin;
	let bottomOfWindow = scrollTop + height;


	/* If the object is completely visible in the window, fade it it */
	if (bottomOfWindow > topOfObject) {
		element.classList.add('loaded');
	}
}

export function getOffset(el) {
	let rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export function initLazy(elements) {
	if (!elements) {
		/**
		 * Selects all elements with a data-src, except iframes.
		 * This stops iframes getting the b-lazy class which lowers their opacity.
		 * This is used for images to give a nice loading effect but they get the
		 * class removed eventually, iframes do not, even when they are loaded fully.
		 */
		elements = document.querySelectorAll('[data-src]:not(iframe)');
	}

	for (let i = 0; i < elements.length; i++) {
		let el = elements[i];
		el.classList.add('b-lazy');
		
		let imgUrl = el.dataset.src.split("?");
		let src = imgUrl[0];
		if (imgUrl.length > 1) {
			let urlParams = new URLSearchParams(imgUrl[1]);
			if (urlParams === null){
				src = src + '?rev=1'
			}
			else {
				src = src + '?rev=' + urlParams.get('rev');
			}
		}
		else {
			src = src + '?rev=1'
		}

		// Added this to allow mw width to not be overwritten by the element width
		if (el.dataset.src.includes('mw=')) {

			let screenHeight = screen.height,
				screenWidth = screen.width;
			let screenMaxSize = screenHeight > screenWidth ? screenHeight : screenWidth; // considering portrait on tablets
			screenMaxSize = screenMaxSize > 1200 ? 1200 : screenMaxSize; // 1200 is max-width of site

			let maxWidth = parseInt(el.dataset.src.split("mw=")[1]);

			if (maxWidth > screenMaxSize) {
				el.dataset.src = src + '&mw=' + screenMaxSize * window.devicePixelRatio;
			}

		} else if (el.dataset.noRestrict) {
			el.dataset.src = el.dataset.src + '?rel=0';
		} else if (!el.dataset.src.includes('w=') && !el.dataset.src.includes('h=')) {
			let height = el.innerHeight || el.clientHeight;
			height = height * window.devicePixelRatio; // Sizes images properly for higher DPI devices

			if (el.dataset.matchHeight) {
				document.querySelectorAll('[data-match-height="' + el.dataset.matchHeight + '"]').forEach(function (element) {
					if (element.offsetHeight > height) {
						height = element.offsetHeight;
					}
				});
			}
			let width = el.clientWidth || el.offsetWidth;
			if (width === 0) {
				width = el.parentNode.clientWidth || el.parentNode.offsetWidth;
			}
			width = width * window.devicePixelRatio; // Sizes images properly for higher DPI devices
			if (el.localName === 'img') {
				let parent = el.parentNode;
				width = parent.clientWidth * window.devicePixelRatio || parent.offsetWidth * window.devicePixelRatio;
			}
			if (el.dataset.src.includes('w=')) {
				el.dataset.src = el.dataset.autoHeight ?
					src + '&w=' + width + '&rel=0' :
					src + '&w=' + width + '&h=' + height + '&rel=0';
			} else {
				const queryDelimiter = el.dataset.src.indexOf('?') > -1 ? '&' : '?';

				el.dataset.src = el.dataset.autoHeight ?
					el.dataset.src + queryDelimiter + 'w=' + width + '&rel=0' :
					el.dataset.src + queryDelimiter + 'w=' + width + '&h=' + height + '&rel=0';
			}
		}
	}
}
